import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from 'firebase/remote-config'

// Import the main Firebase app instance
let remoteConfig = null

/**
 * Initialize Remote Config with the Firebase app instance.
 * This should be called after Firebase is initialized.
 *
 * @param {FirebaseApp} app - The Firebase app instance
 */
export function initRemoteConfig(app) {
  remoteConfig = getRemoteConfig(app)

  remoteConfig.defaultConfig = {
    maintenance_enabled: 'false',
    maintenance_message: process.env.VUE_APP_MAINTENANCE_DEFAULT_MESSAGE || 'System maintenance in progress. We\'ll be back shortly.',
  }

  // Fetch interval: dev = 0 (every time); production = 15 min so maintenance mode reaches in-app users within ~15 min.
  const isDev = process.env.NODE_ENV === 'development'
  const MAINTENANCE_FETCH_INTERVAL_MS = 15 * 60 * 1000 // 15 minutes
  remoteConfig.settings.minimumFetchIntervalMillis = isDev ? 0 : MAINTENANCE_FETCH_INTERVAL_MS
}

/**
 * Fetches maintenance banner config from Remote Config.
 *
 * @returns {Promise<{ enabled: boolean, message: string }>}
 */
export async function getMaintenanceConfig() {
  if (!remoteConfig) {
    console.error('[Maintenance Config] Remote Config not initialized')

    return { enabled: false, message: '' }
  }

  try {
    await fetchAndActivate(remoteConfig)

    const enabled = getValue(remoteConfig, 'maintenance_enabled').asBoolean()
    const message = getValue(remoteConfig, 'maintenance_message').asString() || ''

    return { enabled, message }
  } catch (error) {
    console.error('[Maintenance Config] Error fetching:', error)

    return { enabled: false, message: '' }
  }
}

export { remoteConfig }
